/**
 * 对比双方基本信息（mock v3 最上一段）。
 *
 * 三个版本字段按库里实际有的东西给：
 * - 模型版本 = ``job.algorithm_version`` 归一后的裸版本号。平台里没有独立的「感知
 *   模型版本」列，算法包版本是唯一可用的版本标识；原始全路径挂在 title 上。
 * - 真值标注版本 = 从 ``gt_coverage.scene_id`` 派生。
 * - 判据配置版本 = 库中无此字段，恒 null，此处显示 EMPTY 而不是隐藏行——让「这一格
 *   还没接」在页面上是可见的，而不是看起来只有两个版本。
 */
import { Tooltip } from 'antd';

import type { PerceptionJobHeader } from '@/apis/simulation';

import { EMPTY } from '../format';

const fmtTime = (iso: string | null): string => {
  if (!iso) return EMPTY;
  try {
    return new Date(iso).toLocaleString('zh-CN');
  } catch {
    return iso;
  }
};

interface RowProps {
  label: string;
  value?: string | null;
  /** hover 展示的全文（如算法包完整 bos 路径） */
  title?: string | null;
}

function Row({ label, value, title }: RowProps) {
  const text = value || EMPTY;
  return (
    <div className="pe-side-row">
      <span className="pe-side-row-label">{label}</span>
      <span className="pe-side-row-value">
        {title ? <Tooltip title={title}>{text}</Tooltip> : text}
      </span>
    </div>
  );
}

interface SideInfoProps {
  header: PerceptionJobHeader;
  /** 'base' = 基线（对比方），'current' = 本次 */
  side: 'base' | 'current';
}

export default function SideInfo({ header, side }: SideInfoProps) {
  return (
    <div className={`pe-side pe-side--${side}`}>
      <div className="pe-side-tag">
        {side === 'current' ? '本次' : '基线'} · Job {header.jobId}
        {header.jobName ? ` · ${header.jobName}` : ''}
      </div>
      <Row
        label="模型版本"
        value={header.modelVersion}
        title={header.algorithmVersionRaw}
      />
      <Row label="真值标注版本" value={header.gtVersion} />
      <Row label="判据配置版本" value={header.criteriaVersion} />
      <Row label="创建人" value={header.creator} />
      <Row label="创建时间" value={fmtTime(header.createTime)} />
    </div>
  );
}
